export default "/_next/static/sounds/rory_tipsy-c358ea8ed852b207eb940dafaa378517.mp3";